export interface UserPollResponse {
  data: {
    user: any
    countries: any
    customers: any
    presences: any
    lockerDimensions: any
    lockerPriceCategories: any
    users: any
    sessions: any
    lockers: any
    bookingSourceGroups: any
    etag: string
  }
  id: number
  done: boolean
}

export interface UserPollErrorResponse {
  text: string
}

export enum UserPollRequestType {
  Signin = 1,
  TokenRefresh = 2,
  ForcePoll = 3,
  Signout = 4,
}

export enum UserPollResponseType {
  Poll = 1,
  TokenRefresh = 2,
  Error = 3,
  ConnectionOk = 4,
  ConnectionError = 5,
}
